// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"dae6decd","325":"e8c00740","397":"951c4b64","568":"9563d390","577":"0aa7fed8"}[chunkId] + ".chunk.js";
};